import SvgIcon from './SvgIcon.vue';
import withInstall from '@/shared/withInstall';

export const XSvgIcon = withInstall(SvgIcon);
export default XSvgIcon;
